module.exports = __webpack_public_path__ + "static/media/favorites-filled.cae38eff.svg";